import { IKnmSubjectType } from 'APIPackage/CatalogsModule/interfaces/IKnmSubjectType';

export const createKnmSubjectTypeSelectOption = (knmSubjectType: IKnmSubjectType) => ({
  ...knmSubjectType,
  label: knmSubjectType.name,
  value: knmSubjectType.code,
});
